import PersonComparisonModel from './../../model/personComparisonModel';

export default class Panel {

    private target: HTMLElement;
    private id: string;
    private nameHandler: (event: any) => void;
    private genderHandler: (event: any) => void;
    private birthyearHandler: (event: any) => void;
    private estimateHandler: (event: any) => void;
    private panel!: HTMLElement;
    private name!: HTMLInputElement;
    private gender!: HTMLElement;
    private birthyear!: HTMLElement;
    private estimate!: HTMLElement;

    constructor(target, id) {

        this.target = target;
        this.id = id;

        this.nameHandler = (event) => {this.setName(event.target.value)};
        this.genderHandler = (event) => {this.setGender(event.target.value)};
        this.birthyearHandler = (event) => {this.setBirthyear(event.target.value)};
        this.estimateHandler = (event) => {this.setEstimate(event.target.value)};
    }

    init() {

        // we are tying this panel to an existing element created in selection.twig (div with id)
        const panelElement = this.target.querySelector(`#${this.id}`);
        if (!panelElement) {
            throw new Error(`Panel element with id ${this.id} not found`);
        }
        this.panel = panelElement as HTMLElement;

        this.name = this.panel.querySelectorAll('.name > input')[0] as HTMLInputElement;
        this.gender = this.panel.querySelectorAll('.gender')[0] as HTMLElement;
        this.birthyear = this.panel.querySelectorAll('.birthyear')[0] as HTMLElement;
        this.estimate = this.panel.querySelectorAll('.estimate')[0] as HTMLElement;

        this.name.addEventListener('input', this.nameHandler.bind(this));
        this.gender.addEventListener('change', this.genderHandler.bind(this));
        this.birthyear.addEventListener('change', this.birthyearHandler.bind(this));
        this.estimate.addEventListener('change', this.estimateHandler.bind(this));
    }

    setName(value) {
        PersonComparisonModel.people[this.id].name = value;
    }

    setGender(value) {
        PersonComparisonModel.people[this.id].gender = value.slice(0, 1);
    }

    setBirthyear(value) {
        PersonComparisonModel.people[this.id].birthyear = value;
    }

    setEstimate(value) {
        PersonComparisonModel.people[this.id].estimated_age = value;
    }

    _setDefaults(defaults) {

        if (defaults.name) {
            this.setName(defaults.name);
        }

        if (defaults.gender) {
            this.gender.querySelectorAll('select')[0].value = defaults.gender === 'm' ? 'männlich' : 'weiblich';
            this.setGender(defaults.gender);
        }

        if (defaults.birthyear) {
            this.birthyear.querySelectorAll('select')[0].value = defaults.birthyear;
            this.setBirthyear(defaults.birthyear);
        }

        if (defaults.estimated_age) {
            this.estimate.querySelectorAll('select')[0].value = defaults.estimated_age;
            this.setEstimate(defaults.estimated_age);
        }
    }
}
